import React from 'react';

import { useMetricsConfig } from '@lumapps/metric/hooks/useMetricsConfig';
import { usePendo } from '@lumapps/metric/hooks/usePendo';

/**
 * This is a wrapper component in order to use the usePendo hook
 * in an Angular JS context. This component will be used with the react-element-directive
 * and it will allow us to remove the legacy code for pendo and just reuse the new architecture code.
 */
const UI = ({ config }) => {
    usePendo(config);

    return null;
};

export const Pendo = () => {
    const config = useMetricsConfig();
    if (config.isUserImpersonated) {
        return null;
    }

    return <UI config={config} />;
};
